import { EMPTY_STRING } from 'common/constants';

const getLangFromURLParam = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get('lang') || EMPTY_STRING;
};

export default getLangFromURLParam;
